module.exports = "<go-wrapper [title]=\"UI_TEXTS.GO_LAIR\"\n            [document]=\"document\"\n            [componentType]=\"componentType\">\n  <div class=\"row\">\n    <div class=\"col-md-2\">\n      <nv-input [document]=\"component\"\n                         [pointer]=\"'/period'\"\n                         [label]=\"UI_TEXTS.GO_LAIR_PERIOD\"\n                         [val_type]=\"VALUE_TYPE.UINT\"\n                         [size]=\"12\"></nv-input>\n    </div>\n  </div>\n</go-wrapper>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/go/go-lair/go-lair.component.html
// module id = ../../../../../src/app/components/go/go-lair/go-lair.component.html
// module chunks = 0